import React, { Component } from 'react';
import Footer from '../Footer/FooterContainer';
import Life from './Life/LifeContainer';
import LongTermCare from './LongTermCare/LongTermCareContainer';
import Disability from './Disability/DisabilityContainer';
import { Tasks } from '../../FinancialPlanOPL/Goals/components/Tasks/Tasks';
import { DISABILITY, LIFE, LONG_TERM_CARE } from './InsuranceConstants';
import { ASSUMPTIONS } from '../Explanations/ExplanationsConst';
import InsuranceAssumptions from './InsuranceAssumptions';

export default class InsuranceView extends Component {
  render() {
    const { clientId, fpId, data, selectedSection, insuranceGoal, isPrint } = this.props;

    if (!insuranceGoal) {
      return null;
    }

    return (
      <div className="NewFinancialPlan_Insurance">
        {selectedSection == LIFE && <Life {...this.props} />}
        {selectedSection == LONG_TERM_CARE && <LongTermCare {...this.props} />}
        {selectedSection == DISABILITY && <Disability {...this.props} />}
        {selectedSection == ASSUMPTIONS && <InsuranceAssumptions {...this.props} />}

        {!isPrint && <Tasks />}

        {!isPrint && <Footer data={data} clientId={clientId} fpId={fpId} />}
      </div>
    );
  }
}
